import { mapToBreakpoints } from './mapToBreakpoints.js';
import { rem } from './rem.js';

const spacing = (spacing, multiplier = 2, numberOnly = false) => {
    return numberOnly ? spacing * multiplier : rem(spacing * multiplier);
};
const spaceProp = (steps, prop = 'marginBottom') => {
    return mapToBreakpoints(steps, (step) => {
        const props = Array.isArray(prop) ? prop : [prop];
        return (Object.assign({}, props.reduce((obj, prop) => (Object.assign(Object.assign({}, obj), { [prop]: spacing(step) })), {})));
    });
};
const marginBottomSpacing = (spacingAfter) => {
    return spaceProp(spacingAfter, 'marginBottom');
};

export { marginBottomSpacing, spaceProp, spacing };
//# sourceMappingURL=spacing.js.map
